import { render, staticRenderFns } from "./OutlinkNew.vue?vue&type=template&id=22c87c7c&scoped=true"
import script from "./OutlinkNew.vue?vue&type=script&lang=js"
export * from "./OutlinkNew.vue?vue&type=script&lang=js"
import style0 from "./OutlinkNew.vue?vue&type=style&index=0&id=22c87c7c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c87c7c",
  null
  
)

export default component.exports